import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets the window scroll to the top whenever the route changes.
 * Without this, React Router preserves scroll position from the previous page,
 * which makes new product/category pages open mid-page (or worse, at the bottom).
 *
 * Mount once, near the root, inside the <BrowserRouter>.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Use 'auto' (instant) to avoid the visual stutter of a smooth scroll on every nav.
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
